import './rating.scss';

import axios from 'axios';
import { createElementFromHTML } from './../../utilities/js/helper';

class Rating {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-rating',
            contentAttr: 'content',
            voteAttr: 'vote'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$rating = $element;
        this.$ratingContent = this.$rating.querySelector(`[${this.settings.initAttr}="${this.settings.contentAttr}"]`);
        // this.$ratingVote = this.$purporses.querySelectorAll(`[${this.settings.initAttr}="${this.settings.slideAttr}"]`);

        if (this.$ratingContent) {
            this.initialize();
        }
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$ratingContent.addEventListener('click', (e) => {
            const $target = e.target;
            const targetUri = $target.getAttribute('data-href');

            if (targetUri) {
                this.loadVoting(targetUri);
            }

            e.preventDefault();
        });
    }

    loadVoting (uri) {
        axios({
            method: 'GET',
            url: uri
        })
            .then((result) => {
                let resultError = false;
                if (result && result.data) {
                    const resultData = result.data;

                    if (resultData.success && resultData.success === true && resultData.content) {
                        const $resultContent = createElementFromHTML(resultData.content);

                        if ($resultContent) {
                            this.$ratingContent.innerHTML = $resultContent.innerHTML;
                        } else {
                            console.log('no result content given', resultData.content);
                            resultError = true;
                        }
                    } else {
                        console.log('no result data given', resultData);
                        resultError = true;
                    }
                } else {
                    console.log('no result given', result);
                    resultError = true;
                }

                if (resultError === true) {
                    const $errorMessage = document.createElement('p');
                    $errorMessage.classList.add('recipe-rating__error');
                    if (this.$ratingContent.getAttribute('data-errormessage')) {
                        $errorMessage.innerText = this.$ratingContent.getAttribute('data-errormessage');
                    } else {
                        $errorMessage.innerText = 'An error occurred!';
                    }

                    this.$ratingContent.appendChild($errorMessage);
                }
            })
            .catch((error) => {
                throw Error(error);
            });
    }
}

export { Rating };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$rating = $context.querySelectorAll('[data-rating="root"]');
        for (let i = 0; i < $$rating.length; i++) {
            const $rating = $$rating[i];

            const ratingAPI = new Rating($rating);
            $rating.API = ratingAPI;
        }
    }
});
